import { AccessProfileEnum } from '@/assets/global/enums/AccessProfileEnum'
import { useUserStore } from '@/stores/userStore'
import type { Ref } from 'vue'
import { processApiResponse, Response } from '@/utils/helpers/toggleSnackBar'
import { useToast } from '@/stores/toastStore'

export const copyEmail = (email: { email: string; icon: string }) => {
  navigator.clipboard
    .writeText(email.email)
    .then(() => {
      email.icon = 'tabler-copy-check'

      setTimeout(() => {
        email.icon = 'tabler-copy'
      }, 2000)
    })
    .catch((err) => {
      console.error('Erro ao copiar o texto: ', err)
    })
}

export const checkImage = async (url: string) => {
  return url
    ? await fetch(url, { method: 'HEAD' }).then((res) => res.ok)
    : false
}

export const isCoordinator = (subject: string | undefined) => {
  const userStore = useUserStore()
  return (
    subject === AccessProfileEnum.FUNCTIONALITY.UPDATES &&
    userStore.isCoordinator
  )
}

export const showApiToast = (
  dataResponse: Ref<Response | null>,
  dataResult: Ref<Response | null>,
  errorResult: Ref<Response | null>,
) => {
  const useToastStore = useToast()
  const { showSnackbar, responseCode, responseMessage } =
    storeToRefs(useToastStore)

  processApiResponse(
    responseCode,
    responseMessage,
    showSnackbar,
    dataResponse,
    dataResult as Ref<Response | null>,
    errorResult,
  )

  return responseCode.value
}
